import React from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import styled from "styled-components";

import Navbar from "./global/navbar";
import Sidebar from "./global/sidebar";

// Example pages:
import HomePage from "./pages/homepage";
import GettingStarted from "./pages/docs/gettingstarted";
import Installation from "./pages/docs/installation";

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: linear-gradient(
    to bottom left,
    rgba(69, 160, 73, 1) -80%,
    #1a1a1a 80%
  );
`;

const ContentWrapper = styled.div`
  display: flex;
  flex: 1;
`;

const MainContent = styled.main`
  flex: 1;
  padding: 20px;
  color: #ffffff;
  overflow-y: auto;
`;

const App = () => {
  return (
    <Router>
      <PageContainer>
        {/* Global Navbar */}
        <Navbar />

        <ContentWrapper>
          {/* Global Sidebar */}
          <Sidebar />

          {/* Main content area where routes will render */}
          <MainContent>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/docs/getting-started" element={<GettingStarted />} />
              <Route path="/docs/installation" element={<Installation />} />
              {/* Add more routes as needed */}
            </Routes>
          </MainContent>
        </ContentWrapper>
      </PageContainer>
    </Router>
  );
};

export default App;